var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(!_vm.hideHeader)?_c('home-header'):_vm._e(),_c('a-layout',{class:!_vm.hideHeader ? 'home-layout-head' : 'home-layout'},[(!_vm.hideLeftMenu)?_c('home-sidebar'):_vm._e(),_c('a-layout',{staticClass:"home-content"},[_c('a-layout-content',{style:({
          background: '#fff',
          padding: '0',
          margin: 0,
          height: '100%'
        })},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }